import { render, staticRenderFns } from "./AddMemberModal.vue?vue&type=template&id=671c8299&scoped=true&"
import script from "./AddMemberModal.vue?vue&type=script&lang=js&"
export * from "./AddMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./AddMemberModal.vue?vue&type=style&index=0&id=671c8299&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671c8299",
  null
  
)

export default component.exports